import Building from './pages/Building/Building.vue';
import Router from 'vue-router';
import Vue from 'vue';

Vue.use(Router);

export default new Router({
    mode  : 'history',
    base  : process.env.BASE_URL,
    routes: [{
        path     : '/',
        name     : 'complex',
        component: Building
    }, {
        path     : '/building/:buildingId',
        name     : 'section',
        component: () => {
            return import('./pages/Section/Section.vue');
        }
    }, {
        path     : '/building/:buildingId/section/:sectionId',
        name     : 'floor',
        component: () => {
            return import('./pages/Floor/Floor.vue');
        }
    }, {
        path     : '/building/:buildingId/section/:sectionId/floor/:floorId',
        name     : 'flat',
        component: () => {
            return import('./pages/Flat/Flat.vue');
        }
    }]
});
